import { Badge } from "@chakra-ui/react"

import React from "react"

interface BadgeProps {
  text: string
}

function CustomBadge({ text }: BadgeProps): JSX.Element {
  return (
    <Badge
      background="transparent"
      color="purple.500"
      fontSize={{ base: "sm", md: "md" }}
      margin="0"
      padding="0"
      textTransform="uppercase"
      letterSpacing={"wide"}
    >
      {text}
    </Badge>
  )
}

export default CustomBadge
